import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrdersSearchPageComponent } from './components/orders-search-page.component';
import { SaleOrderDetailsComponent } from './components/sale-order-details/sale-order-details.component';
import { InvatOrderSearchPageComponent } from './invat-order-search-page/invat-order-search-page.component';
import { InvatOrderUploadHistoryPageComponent } from './invat-order-upload-history-page/invat-order-upload-history-page.component';
import { SaleOrderResolver } from './services/resolvers/sale-order-resolver.service';
import { B2BSaleOrdersSearchPageComponent } from './b2b-sales-order-management/components/b2b-sale-orders-search-page.component';
import { SaleOrderMarketplaceTemplatesComponent } from './components/so-marketplace-templates/so-marketplace-templates.component';
import { SaleOrderTemplateDetailsComponent } from './components/so-marketplace-templates/so-template-details/so-template-details.component';
import { SaleOrderFromXlsxComponent } from './components/so-from-xlsx/so-from-xlsx.component';
import {
    MarketplaceSalesOrderPageComponent
} from "./marketplace-sales-order/components/marketplace-sales-order-page.component";
import {AuthGuard} from './../../core/services/auth-guard.service';

const routes: Routes = [
  { path: '', component: OrdersSearchPageComponent },
  { path: 'b2b-sales-order-management',
  canActivate: [AuthGuard],
  canActivateChild: [AuthGuard],
  data: {roles: ['ADMIN', 'CUSTOMER', 'DELICATE_ADMIN', 'DELICATE_CUSTOMER', 'MARKETPLACE', 'OFFLINE_SHOP_OWNER', 'IND_VAT_ACCOUNT', 'PARTNER_ACCOUNT', 'DELICATE_PARTNER_ACCOUNT', 'DELEGATE_OFFLINE_SHOP_OWNER']},
  component: B2BSaleOrdersSearchPageComponent },
  { path: 'marketplace-sales-management', component: MarketplaceSalesOrderPageComponent },
  { path: 'indvat-sales-order-management', component: InvatOrderSearchPageComponent },
  { path: 'indvat-sales-order-upload-history', component: InvatOrderUploadHistoryPageComponent },
  {
    path: 'order-details/:id',
    component: SaleOrderDetailsComponent,
    resolve: {
      data: SaleOrderResolver
    }
  },
  {
    path: 'so-marketplace-templates',
    component: SaleOrderMarketplaceTemplatesComponent,
    pathMatch: 'full',
  },
  {
    path: 'so-marketplace-templates/details',
    component: SaleOrderTemplateDetailsComponent,
    pathMatch: 'full',
  },
  {
    path: 'so-marketplace-templates/details/:id',
    component: SaleOrderTemplateDetailsComponent,
    pathMatch: 'full',
  },
  {
    path: 'so-from-xlsx',
    component: OrdersSearchPageComponent,
    data: {
      isXlsx: true,
    }
  },
  {
    path: 'so-from-xlsx-failed',
    component: OrdersSearchPageComponent,
    data: {
      isXlsx: true,
      isFailed: true,
    }
  },
  {
    path: 'xlsx-uploaded',
    component: SaleOrderFromXlsxComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesOrderManagementRoutingModule {
}
